<template>
  <SelectComponent
    v-model="localModelValue"
    :values="filteredOptions"
    :searchable="searchable"
    :label="cLabel"
    :placeholder="cLabel"
    :track-by="trackBy"
    :display-key="attributeLabel"
    :required="required"
    :errors="errors?.[errorsKey] ?? []"
    :name="name"
    :edition-mode="editionMode"
  />
</template>

<script>
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'

/**
 * User select limited to the users still in office (no `exit_date`, or one
 * in the future), from `metadata.users`.
 */
export default {
  name: 'BaseShowEditFilteredUsersComponent',
  components: { SelectComponent },
  props: {
    editionMode: { type: Boolean, default: true },
    modelValue: {
      type: [Number, String, Object],
      required: false,
      default: null
    },
    trackBy: { type: String, required: false, default: 'id' },
    attributeLabel: { type: String, required: false, default: 'name' },
    label: { type: String, required: false, default: null },
    name: { type: String, required: false, default: 'user_id' },
    errors: { type: Object, required: false, default: () => ({}) },
    errorsKey: { type: String, required: false, default: 'user_id' },
    metadata: { type: [Object, Array], required: true },
    required: { type: Boolean, required: false, default: false },
    searchable: { type: Boolean, required: false, default: false }
  },
  emits: ['update:modelValue'],
  computed: {
    cLabel() {
      return this.label ? this.label : this.$t('attributes.user')
    },
    filteredOptions() {
      return (
        this.metadata?.users?.filter((user) => {
          return !user.exit_date || new Date(user.exit_date) > new Date()
        }) ?? []
      )
    },
    localModelValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value ?? null)
      }
    }
  }
}
</script>
